import { render, staticRenderFns } from "./ContestCriteriaListComponent.vue?vue&type=template&id=4aa41578"
import script from "./ContestCriteriaListComponent.vue?vue&type=script&lang=js"
export * from "./ContestCriteriaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports